import { render, staticRenderFns } from "./ScreeningsUpdateFirstSteps.vue?vue&type=template&id=1287dc33&scoped=true&"
import script from "./ScreeningsUpdateFirstSteps.vue?vue&type=script&lang=js&"
export * from "./ScreeningsUpdateFirstSteps.vue?vue&type=script&lang=js&"
import style0 from "./ScreeningsUpdateFirstSteps.vue?vue&type=style&index=0&id=1287dc33&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1287dc33",
  null
  
)

export default component.exports